<template>
    <section class="Section">
        <div class="Container WhiteBox">            
            <FiltroInterventi :showStatoFilter="true" @FiltraInterventi="this.filtraInterventi($event)" @RimuoviFiltri="this.rimuoviFiltri"></FiltroInterventi>
        </div>
        <div class="Container Counter">
            <GrigliaInterventiStorico :listaInterventi="this.listaInterventi"></GrigliaInterventiStorico>
        </div>
    </section> 
</template>
<script>

import FiltroInterventi from "@/components/FiltroInterventi.vue";
import {apiMixin, interventiMixin} from "/mixin.js";
import Intervento from "@/models/intervento.model.js";
import GrigliaInterventiStorico from "@/components/GrigliaInterventiStorico.vue";

export default {
    name: "StoricoInterventi",
    components: {
        FiltroInterventi,
        GrigliaInterventiStorico
    },
    
    mixins: [apiMixin, interventiMixin],
    mounted(){
        this.doApiCall("get", "interventi/GetInterventiChiusi", this.$store.getters.getUtente.Token).then(

                (data) => {                
                    if(data){
                        this.listaInterventi = data.map(o => {
                            return Object.assign(new Intervento(), o)
                        });
                    this.listaInterventiOriginale = this.listaInterventi;
                    }
                }
            );
        }
}
</script>